import { render, staticRenderFns } from "./explain-dialog.vue?vue&type=template&id=0923ce0f&"
import script from "./explain-dialog.vue?vue&type=script&lang=js&"
export * from "./explain-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports